import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/**
 * Serializable preview VM for `PaymentMethodPickerBlockComponent`.
 * Handles are resolved to full method descriptors (labels/logos/panels) in the webapp.
 */
export type PaymentMethodPickerBlockScenarioContent = {
  availablePaymentMethodHandles: readonly string[];
  orderFinalPrice: number | null;
  remainingMinutes: number | null;
  isRetryInProgress: boolean;
};

export const PAYMENTMETHODPICKERBLOCKCOMPONENT_LEGACY_FIELD_ORDER = [
  "bottom_margin",
  "heading_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  paymentMethodPickerBlockDescriptor: _generatedPaymentMethodPickerBlockDescriptor,
  paymentMethodPickerBlockBlocDefinition,
  paymentMethodPickerBlockDashboardLayout,
  paymentMethodPickerBlockConfig,
  paymentMethodPickerBlockResolveConfig,
  paymentMethodPickerBlockProperties,
  paymentMethodPickerBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Payment page - Payment method picker",
    componentType: 'PaymentMethodPickerBlockComponent',
    category: 'content',
    description: "Payment page - Payment method picker.",
    keywords: [],
    allowedIn: [
      { bloc: 'PaymentPageComponent', slot: 'body' },
    ],

    sharedFields: {}
  },

  () => ({
    bottom_margin: propertyValue({
      type: 'select',
      value: "large",
      options: {
        label: "pages.blocks.payment-method-picker.bottom-margin.label",
        choices: [
          {
            value: "none",
            label: "pages.blocks.payment-method-picker.bottom-margin.options.none",
          },
          {
            value: "small",
            label: "pages.blocks.payment-method-picker.bottom-margin.options.small",
          },
          {
            value: "large",
            label: "pages.blocks.payment-method-picker.bottom-margin.options.large",
          }
        ]
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.payment-method-picker.heading-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.payment-method-picker.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.payment-method-picker.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.payment-method-picker.fieldset.spacing.label",
            fields: ["bottom_margin"],
          },
          {
            legend: "pages.blocks.payment-method-picker.fieldset.titles.label",
            fields: ["heading_color"],
          },
          {
            legend: "pages.blocks.payment-method-picker.fieldset.texts.label",
            fields: ["text_color"],
          },
        ],
      },
    ],
  })
);

export function paymentMethodPickerBlockDescriptor(): IBlockDescriptor;
export function paymentMethodPickerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function paymentMethodPickerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPaymentMethodPickerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPaymentMethodPickerBlockDescriptor, paymentMethodPickerBlockProperties, fieldOrder);
}

export {
  paymentMethodPickerBlockBlocDefinition,
  paymentMethodPickerBlockDashboardLayout,
  paymentMethodPickerBlockProperties,
  paymentMethodPickerBlockConfig,
  paymentMethodPickerBlockResolveConfig,
  paymentMethodPickerBlockDefinitionSetupScenarios,
};

export type PaymentMethodPickerBlockConfig = typeof paymentMethodPickerBlockConfig;
